import { wasApiErrorJustNotified } from "@services/api/apiError";
import { SnackbarKey, useSnackbar } from "notistack";

type MessageParams = {
  message?: string;
};

const useSnackbarMessage = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const createAction = (key: SnackbarKey | undefined) => (
    <span
      className="material-symbols-outlined text-[16px] text-text-base cursor-pointer"
      onClick={() => closeSnackbar(key)}
    >
      close
    </span>
  );

  const handleError = ({ message = "Error!" }: MessageParams) => {
    if (wasApiErrorJustNotified()) return;

    enqueueSnackbar(message, {
      variant: "error",
      autoHideDuration: 2000,
      style: {
        backgroundColor: "#FFE8E8",
        color: "#15182C",
      },
      action: (key) => createAction(key),
    });
  };

  const handleSuccess = ({ message = "Success!" }: MessageParams) => {
    enqueueSnackbar(message, {
      variant: "success",
      autoHideDuration: 2000,
      style: {
        backgroundColor: "#EFFCF3",
        color: "#15182C",
      },
      action: (key) => createAction(key),
    });
  };

  return { handleError, handleSuccess };
};

export default useSnackbarMessage;
